import { FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function validateMinStartDate(minStartDate: string | Date): ValidatorFn {
  return (control: FormControl): ValidationErrors => {
    let error: ValidationErrors = null;

    const startDateTime = new Date(control.value);
    const minStartDateTime = new Date(minStartDate);

    if (minStartDate && startDateTime < minStartDateTime) {
      error = { startDateIsLessThanMinStartDate: true };
    }

    return error;
  };
}

export function validateMaxEndDate(maxEndDate: string | Date): ValidatorFn {
  return (control: FormControl): ValidationErrors => {
    let error: ValidationErrors = null;

    const maxEndDateTime = new Date(maxEndDate);
    const endDateTime = new Date(control.value);

    if (maxEndDate && endDateTime > maxEndDateTime) {
      error = { endDateIsGreaterThanMaxEndDate: true };
    }

    return error;
  };
}